import { isTestnet } from "../config/network";

const REFERRAL_NETWORKS = {
  mainnet: {
    keeperUrl: "https://sai-keeper.nibiru.fi/query",
    evmRpc: "https://evm-rpc.nibiru.fi:443",
    evmInterfaceAddress: "0x9F48A925Dda8528b3A5c2A6717Df0F03c8b167c0",
    evmChainId: 6900,
  },
  testnet: {
    keeperUrl: "https://sai-keeper.testnet-2.nibiru.fi/query",
    evmRpc: "https://evm-rpc.testnet-2.nibiru.fi:443",
    evmInterfaceAddress: "0xC89Cd9fB1f2A77fAdCa62cCc4df21698cFFFaac9",
    evmChainId: 6911,
  },
};

export const REFERRAL_CODE = "ESTATE";

export const EVM_INTERFACE_ABI = [
  "function executeSimpleFunctions(bytes wasmMsgExecute) external",
];

export const getReferralConfig = () => {
  const network = isTestnet() ? "testnet" : "mainnet";
  const config = REFERRAL_NETWORKS[network];

  return {
    ...config,
    keeperUrl:
      process.env.REACT_APP_SAI_KEEPER_URL || config.keeperUrl,
    evmInterfaceAddress:
      process.env.REACT_APP_SAI_EVM_INTERFACE_ADDRESS || config.evmInterfaceAddress,
  };
};
